import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Scale, 
  BookOpen, 
  FileText, 
  FileCheck, 
  DollarSign, 
  Shield, 
  CheckSquare, 
  Copyright, 
  Store,
  ArrowRight,
  Search
} from 'lucide-react';
import Navbar from '../../components/layout/Navbar';

const AllServicesPage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('all');

  // جميع الخدمات مقسمة حسب الدوائر
  const allServices = [
    {
      divisionId: 'litigation',
      divisionNameAr: 'دائرة التقاضي',
      divisionNameEn: 'Litigation Department',
      icon: Scale,
      color: 'blue',
      services: [
        { nameAr: 'رفع صحائف الدعاوى أمام الجهات القضائية المختصة', nameEn: 'Filing lawsuits before competent judicial authorities' },
        { nameAr: 'إعداد لوائح الاعتراض على الأحكام (استئناف / نقض / التماس إعادة نظر)', nameEn: 'Preparing objection petitions (appeal / cassation / review)' },
        { nameAr: 'المرافعة أمام المحاكم بمختلف درجاتها', nameEn: 'Pleading before courts of all levels' },
        { nameAr: 'حضور الجلسات القضائية وتمثيل العملاء', nameEn: 'Attending court hearings and representing clients' },
        { nameAr: 'تقديم المذكرات القانونية والردود النظامية', nameEn: 'Submitting legal briefs and regulatory responses' },
        { nameAr: 'إدارة ملف القضية كاملاً من القيد حتى التنفيذ أو الإغلاق', nameEn: 'Complete case file management from registration to execution or closure' },
        { nameAr: 'تقديم الاستئناف على الأحكام الابتدائية', nameEn: 'Filing appeals against primary judgments' },
        { nameAr: 'تقديم الاعتراضات أمام الجهات القضائية المختصة', nameEn: 'Filing objections before competent judicial authorities' },
        { nameAr: 'رفع طلبات التنفيذ القضائي ومتابعتها', nameEn: 'Filing and following up execution requests' },
        { nameAr: 'تقديم طلبات وقف التنفيذ عند توافر شروطه', nameEn: 'Filing stay of execution requests when conditions are met' },
        { nameAr: 'الترافع في الطعون الإدارية على القرارات الحكومية', nameEn: 'Pleading in administrative appeals against government decisions' },
        { nameAr: 'متابعة الإشعارات والمراسلات القضائية إلكترونياً', nameEn: 'Following up notifications and court correspondence electronically' },
        { nameAr: 'التفاوض والصلح في القضايا قبل وأثناء سير الدعوى', nameEn: 'Negotiation and settlement in cases before and during proceedings' },
        { nameAr: 'إعداد تقارير دورية لسير القضايا لعرضها على العميل أو الإدارة', nameEn: 'Preparing periodic reports on case progress for clients or management' }
      ]
    },
    {
      divisionId: 'consultation',
      divisionNameAr: 'دائرة الدراسات والاستشارات',
      divisionNameEn: 'Studies and Consultation Department',
      icon: BookOpen,
      color: 'green',
      services: [
        { nameAr: 'تقديم الاستشارات القانونية المكتوبة المفصلة', nameEn: 'Providing detailed written legal consultations' },
        { nameAr: 'تقديم الاستشارات القانونية الشفوية/الهاتفية/الأونلاين', nameEn: 'Providing oral/phone/online legal consultations' },
        { nameAr: 'إعداد الدراسات القانونية المتخصصة حول موضوعات محددة', nameEn: 'Preparing specialized legal studies on specific topics' },
        { nameAr: 'تحليل المخاطر القانونية المرتبطة بنشاط العميل', nameEn: 'Analyzing legal risks related to client activities' },
        { nameAr: 'إعداد الرأي القانوني (Legal Opinion) المعتمد', nameEn: 'Preparing certified Legal Opinion' },
        { nameAr: 'مراجعة القرارات واللوائح الداخلية من منظور نظامي', nameEn: 'Reviewing internal decisions and regulations from legal perspective' },
        { nameAr: 'تحليل الأنظمة واللوائح السعودية ذات العلاقة بنشاط العميل', nameEn: 'Analyzing Saudi regulations related to client activities' },
        { nameAr: 'تقديم استشارات عاجلة وفورية في الحالات الحرجة', nameEn: 'Providing urgent and immediate consultations in critical cases' },
        { nameAr: 'تقديم باقات استشارية شهرية وسنوية للشركات والجهات', nameEn: 'Providing monthly and annual consultation packages for companies' }
      ]
    },
    {
      divisionId: 'contracts',
      divisionNameAr: 'دائرة العقود والشركات',
      divisionNameEn: 'Contracts and Companies Department',
      icon: FileText,
      color: 'purple',
      services: [
        { nameAr: 'صياغة العقود التجارية بمختلف أنواعها (بيع، شراء، توريد، تقديم خدمات، شراكات)', nameEn: 'Drafting commercial contracts of all types' },
        { nameAr: 'مراجعة العقود والتحقق من سلامتها النظامية ومصالح العميل', nameEn: 'Reviewing contracts and verifying legal soundness and client interests' },
        { nameAr: 'تعديل العقود القائمة بما يتوافق مع الأنظمة والتغييرات التجارية', nameEn: 'Amending existing contracts in accordance with regulations' },
        { nameAr: 'صياغة مذكرات التفاهم (MoU) والاتفاقات المبدئية', nameEn: 'Drafting Memorandums of Understanding (MoU) and preliminary agreements' },
        { nameAr: 'صياغة ومراجعة السياسات واللوائح الداخلية للشركات', nameEn: 'Drafting and reviewing internal policies and regulations for companies' },
        { nameAr: 'تأسيس الشركات بجميع أنواعها وفقاً للأنظمة السعودية', nameEn: 'Establishing companies of all types according to Saudi regulations' },
        { nameAr: 'تعديل عقود تأسيس الشركات وقرارات الشركاء', nameEn: 'Amending company formation contracts and partners decisions' },
        { nameAr: 'إنهاء إجراءات تسجيل الشركات أمام الجهات المختصة', nameEn: 'Completing company registration procedures with competent authorities' },
        { nameAr: 'إعداد محاضر الجمعيات والاجتماعات للشركاء أو المساهمين', nameEn: 'Preparing assembly and meeting minutes for partners or shareholders' },
        { nameAr: 'إعداد وتنفيذ برامج الحوكمة الداخلية للشركات', nameEn: 'Preparing and implementing internal governance programs for companies' },
        { nameAr: 'إعداد اتفاقيات الشركاء (Shareholders Agreements)', nameEn: 'Preparing Shareholders Agreements' },
        { nameAr: 'صياغة عقود العمل والسياسات المرتبطة بالعلاقة العمالية', nameEn: 'Drafting employment contracts and labor-related policies' },
        { nameAr: 'إعداد وصياغة عقود الامتياز التجاري الداخلي بالتكامل مع دائرة الامتياز', nameEn: 'Preparing domestic franchise contracts in integration with Franchise Department' }
      ]
    },
    {
      divisionId: 'notarization',
      divisionNameAr: 'دائرة التوثيق',
      divisionNameEn: 'Notarization Department',
      icon: FileCheck,
      color: 'indigo',
      services: [
        { nameAr: 'إعداد وصياغة الوكالات الشرعية والوكالات الخاصة', nameEn: 'Preparing and drafting legal powers of attorney and special powers' },
        { nameAr: 'إعداد عقود التوثيق الرسمية (مثل عقود البيع والهبة ونقل الحصص)', nameEn: 'Preparing official notarization contracts' },
        { nameAr: 'توثيق الإقرارات والتعهدات الرسمية', nameEn: 'Notarizing official declarations and undertakings' },
        { nameAr: 'توثيق محاضر الاجتماعات والقرارات ذات الطابع الرسمي', nameEn: 'Notarizing meeting minutes and official decisions' },
        { nameAr: 'توثيق عقود الشركات والتعديلات المرتبطة بها بالتنسيق مع الجهات المختصة', nameEn: 'Notarizing company contracts and related amendments' },
        { nameAr: 'متابعة وإنهاء إجراءات التوثيق لدى كتابات العدل والجهات الحكومية المختصة', nameEn: 'Following up and completing notarization procedures' }
      ]
    },
    {
      divisionId: 'collection',
      divisionNameAr: 'دائرة التحصيل والتسويات الودية',
      divisionNameEn: 'Collection and Settlements Department',
      icon: DollarSign,
      color: 'amber',
      services: [
        { nameAr: 'تحصيل الديون التجارية نيابة عن الأفراد والشركات', nameEn: 'Collecting commercial debts on behalf of individuals and companies' },
        { nameAr: 'إعداد وإرسال خطابات المطالبة الرسمية للمدينين', nameEn: 'Preparing and sending official demand letters to debtors' },
        { nameAr: 'التفاوض لعقد التسويات الودية قبل اللجوء للتقاضي', nameEn: 'Negotiating amicable settlements before resorting to litigation' },
        { nameAr: 'إعداد محاضر واتفاقيات التسوية وسداد الديون', nameEn: 'Preparing settlement minutes and debt payment agreements' },
        { nameAr: 'متابعة تنفيذ خطط السداد المتفق عليها مع المدينين', nameEn: 'Following up implementation of agreed payment plans with debtors' },
        { nameAr: 'إدارة التحصيل القضائي بالتنسيق مع دائرة التقاضي', nameEn: 'Managing judicial collection in coordination with Litigation Department' },
        { nameAr: 'تحصيل الشيكات المرتجعة والمستحقات المالية', nameEn: 'Collecting bounced checks and financial dues' },
        { nameAr: 'تحصيل الفواتير المتعثرة والمطالبات التجارية', nameEn: 'Collecting overdue invoices and commercial claims' },
        { nameAr: 'إعداد تقارير دورية عن حالة المطالبات والتحصيل', nameEn: 'Preparing periodic reports on claims and collection status' },
        { nameAr: 'تقديم توصيات قانونية وإجرائية حول جدوى الاستمرار في التحصيل أو التسوية', nameEn: 'Providing legal and procedural recommendations on feasibility of continuing collection' }
      ]
    },
    {
      divisionId: 'cybercrime',
      divisionNameAr: 'دائرة الجرائم المعلوماتية',
      divisionNameEn: 'Cybercrime Department',
      icon: Shield,
      color: 'red',
      services: [
        { nameAr: 'إدارة قضايا الابتزاز الإلكتروني وحماية الضحايا', nameEn: 'Managing electronic blackmail cases and protecting victims' },
        { nameAr: 'معالجة قضايا اختراق الحسابات الإلكترونية والتطبيقات', nameEn: 'Handling electronic accounts and applications hacking cases' },
        { nameAr: 'قضايا التشهير الإلكتروني عبر منصات التواصل', nameEn: 'Electronic defamation cases via social media platforms' },
        { nameAr: 'قضايا انتحال الهوية والحسابات الوهمية', nameEn: 'Identity theft and fake accounts cases' },
        { nameAr: 'قضايا الاحتيال الإلكتروني والمعاملات المالية الإلكترونية', nameEn: 'Electronic fraud and electronic financial transactions cases' },
        { nameAr: 'الترافع في القضايا المرتبطة بالجرائم المعلوماتية أمام الجهات المختصة', nameEn: 'Pleading in cybercrime cases before competent authorities' },
        { nameAr: 'التنسيق مع الجهات المختصة في الأمن السيبراني والجهات الأمنية', nameEn: 'Coordinating with cybersecurity and security authorities' },
        { nameAr: 'تقديم استشارات وقائية تتعلق بالأمن السيبراني القانوني وحماية السمعة الرقمية', nameEn: 'Providing preventive consultations on legal cybersecurity and digital reputation protection' }
      ]
    },
    {
      divisionId: 'compliance',
      divisionNameAr: 'دائرة الامتثال والحوكمة',
      divisionNameEn: 'Compliance and Governance Department',
      icon: CheckSquare,
      color: 'teal',
      services: [
        { nameAr: 'إعداد سياسات الامتثال الداخلي للشركات والمنشآت', nameEn: 'Preparing internal compliance policies for companies and establishments' },
        { nameAr: 'تصميم وتطبيق نماذج الحوكمة المؤسسية', nameEn: 'Designing and implementing institutional governance models' },
        { nameAr: 'إعداد أدلة الموظف ولوائح السلوك الوظيفي', nameEn: 'Preparing employee manuals and professional conduct regulations' },
        { nameAr: 'إعداد وإصدار لوائح تنظيم العمل وفق نظام العمل السعودي', nameEn: 'Preparing work regulation bylaws according to Saudi Labor Law' },
        { nameAr: 'مراجعة مدى التزام المنشأة بالأنظمة واللوائح ذات العلاقة', nameEn: 'Reviewing establishment compliance with relevant regulations' },
        { nameAr: 'إجراء تقييم قانوني شامل للشركات من منظور الامتثال والحوكمة', nameEn: 'Conducting comprehensive legal assessment from compliance and governance perspective' },
        { nameAr: 'تنفيذ تدقيق امتثال دوري (Compliance Audit) وتقديم التقارير', nameEn: 'Implementing periodic compliance audit and providing reports' },
        { nameAr: 'إعداد سياسات وإجراءات مكافحة الاحتيال والرشوة وتضارب المصالح', nameEn: 'Preparing anti-fraud, anti-bribery, and conflict of interest policies' }
      ]
    },
    {
      divisionId: 'ip',
      divisionNameAr: 'دائرة الملكية الفكرية',
      divisionNameEn: 'Intellectual Property Department',
      icon: Copyright,
      color: 'pink',
      services: [
        { nameAr: 'تسجيل العلامات التجارية محلياً ودولياً حسب الإمكان', nameEn: 'Registering trademarks locally and internationally as possible' },
        { nameAr: 'تسجيل حقوق الملكية الفكرية وحقوق المؤلف', nameEn: 'Registering intellectual property and copyright' },
        { nameAr: 'متابعة طلبات تسجيل العلامات والتجاوب مع ملاحظات الجهات المختصة', nameEn: 'Following up trademark registration applications and responding to authorities remarks' },
        { nameAr: 'إدارة الاعتراضات على تسجيل العلامات أو رفضها', nameEn: 'Managing objections to trademark registration or rejection' },
        { nameAr: 'إدارة النزاعات المتعلقة بالتعدي على العلامات التجارية وحقوق الملكية', nameEn: 'Managing disputes related to trademark infringement and IP rights' },
        { nameAr: 'حماية الأسرار التجارية والبرمجيات والمحتوى الرقمي', nameEn: 'Protecting trade secrets, software, and digital content' },
        { nameAr: 'إعداد وصياغة عقود وترخيص استخدام العلامات والحقوق الفكرية', nameEn: 'Preparing trademark and IP licensing contracts' }
      ]
    },
    {
      divisionId: 'franchise',
      divisionNameAr: 'دائرة الامتياز التجاري',
      divisionNameEn: 'Franchise Department',
      icon: Store,
      color: 'orange',
      services: [
        { nameAr: 'إعداد وثائق الامتياز التجاري (Franchise Disclosure Documents)', nameEn: 'Preparing Franchise Disclosure Documents' },
        { nameAr: 'إعداد وصياغة عقود الامتياز التجاري بما يحقق حماية الحقوق للطرفين', nameEn: 'Preparing franchise contracts ensuring rights protection for both parties' },
        { nameAr: 'مراجعة وتدقيق وثائق وعقود الامتياز التجاري القائمة', nameEn: 'Reviewing and auditing existing franchise documents and contracts' },
        { nameAr: 'إنهاء إجراءات تسجيل الامتياز التجاري لدى الجهات المختصة', nameEn: 'Completing franchise registration procedures with competent authorities' },
        { nameAr: 'إعداد أدلة التشغيل (Operations Manuals) بالتنسيق مع المستفيد', nameEn: 'Preparing Operations Manuals in coordination with beneficiary' },
        { nameAr: 'معالجة المخالفات والنزاعات المتعلقة بعقود الامتياز التجاري، وتمثيل الأطراف عند الحاجة', nameEn: 'Handling violations and disputes related to franchise contracts' }
      ]
    }
  ];

  const colorClasses = {
    blue: 'from-wazin-navy to-wazin-navy-600',
    green: 'from-wazin-gold to-wazin-gold-600',
    purple: 'from-wazin-navy-400 to-wazin-navy-600',
    indigo: 'from-wazin-gold-500 to-wazin-gold-700',
    amber: 'from-wazin-gold-400 to-wazin-gold-600',
    red: 'from-wazin-navy-500 to-wazin-navy-700',
    teal: 'from-wazin-gold-600 to-wazin-navy-600',
    pink: 'from-wazin-navy-600 to-wazin-gold-600',
    orange: 'from-wazin-gold to-wazin-gold-700'
  };

  // Filter services based on search and division
  const filteredDivisions = allServices.filter(division => {
    if (selectedDivision !== 'all' && division.divisionId !== selectedDivision) {
      return false;
    }
    
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      return (
        division.divisionNameAr.toLowerCase().includes(search) ||
        division.divisionNameEn.toLowerCase().includes(search) ||
        division.services.some(service => 
          service.nameAr.toLowerCase().includes(search) || 
          service.nameEn.toLowerCase().includes(search)
        )
      );
    }
    
    return true;
  });

  const totalServices = allServices.reduce((sum, div) => sum + div.services.length, 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-wazin-gold-50 to-wazin-navy-50" dir="rtl">
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-wazin-navy to-wazin-navy-dark text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center text-white">
            جميع الخدمات القانونية
          </h1>
          <p className="text-xl text-center text-wazin-gold-100 mb-2">
            نقدم لكم {totalServices}+ خدمة قانونية متخصصة عبر 9 دوائر قانونية
          </p>
          <p className="text-center text-wazin-gold-200">
            All Legal Services - {totalServices}+ specialized services across 9 legal divisions
          </p>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="container mx-auto px-4 -mt-8 mb-12">
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <div className="grid md:grid-cols-2 gap-4">
            {/* Search Box */}
            <div className="relative">
              <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="ابحث عن خدمة..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pr-12 pl-4 py-3 border-2 border-gray-200 rounded-xl focus:border-amber-600 focus:outline-none"
              />
            </div>

            {/* Division Filter */}
            <select
              value={selectedDivision}
              onChange={(e) => setSelectedDivision(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-amber-600 focus:outline-none"
            >
              <option value="all">جميع الدوائر</option>
              {allServices.map(division => (
                <option key={division.divisionId} value={division.divisionId}>
                  {division.divisionNameAr}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Services by Division */}
      <div className="container mx-auto px-4 pb-16">
        {filteredDivisions.map((division, index) => (
          <div key={division.divisionId} className="mb-16">
            {/* Division Header */}
            <div className="flex items-center gap-4 mb-8">
              <div className={`p-4 rounded-2xl bg-gradient-to-br ${colorClasses[division.color]} shadow-lg`}>
                <division.icon className="text-white" size={32} />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-800">
                  {division.divisionNameAr}
                </h2>
                <p className="text-gray-600">{division.divisionNameEn}</p>
                <p className="text-sm text-gray-500 mt-1">
                  {division.services.length} خدمة متاحة
                </p>
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {division.services.map((service, serviceIndex) => (
                <div
                  key={serviceIndex}
                  className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group border-2 border-transparent hover:border-amber-500"
                >
                  <div className={`h-2 bg-gradient-to-r ${colorClasses[division.color]}`}></div>
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-3 leading-relaxed">
                      {service.nameAr}
                    </h3>
                    <p className="text-sm text-gray-500 mb-4">
                      {service.nameEn}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-400 bg-gray-100 px-3 py-1 rounded-full">
                        {division.divisionNameAr}
                      </span>
                      <button
                        onClick={() => navigate(`/book-consultation?service=${encodeURIComponent(service.nameAr)}&division=${division.divisionId}`)}
                        className="flex items-center gap-2 text-wazin-gold-700 font-semibold hover:text-wazin-gold transition-colors group-hover:gap-3"
                      >
                        اطلب الخدمة
                        <ArrowRight size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* View Division Button */}
            <div className="mt-8 text-center">
              <button
                onClick={() => navigate(`/services/${division.divisionId}`)}
                className={`inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r ${colorClasses[division.color]} text-white rounded-xl font-semibold hover:shadow-lg transition-all`}
              >
                عرض تفاصيل {division.divisionNameAr}
                <ArrowRight size={20} />
              </button>
            </div>
          </div>
        ))}

        {/* No Results */}
        {filteredDivisions.length === 0 && (
          <div className="text-center py-16">
            <p className="text-2xl text-gray-500 mb-4">لا توجد نتائج</p>
            <p className="text-gray-400">جرب البحث بكلمات مختلفة</p>
          </div>
        )}
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-wazin-navy to-wazin-navy-dark text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            لم تجد الخدمة التي تبحث عنها؟
          </h2>
          <p className="text-xl text-wazin-gold-100 mb-8">
            تواصل معنا وسنساعدك في إيجاد الحل القانوني المناسب
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="bg-wazin-gold text-wazin-navy px-8 py-4 rounded-xl font-bold text-lg hover:bg-wazin-gold-light transition-all shadow-lg hover:shadow-xl"
          >
            تواصل معنا الآن
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllServicesPage;
